export const MIME_TYPE_CSV = 'text/csv'
export const MIME_TYPE_STEP = 'model/step'
export const MIME_TYPE_GLB = 'model/gltf-binary'
export const MIME_TYPE_DOCX =
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
export const MIME_TYPE_DOC = 'application/msword'
export const MIME_TYPE_PDF = 'application/pdf'

export const extensionToMimeType: Record<string, string> = {
  heic: 'image/heic',
  heif: 'image/heif',
  jpg: 'image/jpeg',
  jpeg: 'image/jpeg',
  png: 'image/png',
  webp: 'image/webp',
  svg: 'image/svg+xml',
  avif: 'image/avif',
  gif: 'image/gif',
  bmp: 'image/bmp',
  pdf: MIME_TYPE_PDF,
  docx: MIME_TYPE_DOCX,
  doc: MIME_TYPE_DOC,
  mp4: 'video/mp4',
  webm: 'video/webm',
  mov: 'video/quicktime',
  step: MIME_TYPE_STEP,
  stp: MIME_TYPE_STEP,
  glb: MIME_TYPE_GLB,
}

export const mimeTypeToExtension: Record<string, string> = {
  'image/png': 'png',
  'image/jpeg': 'jpg',
  'image/jpg': 'jpg',
  'image/gif': 'gif',
  'image/webp': 'webp',
  'image/heic': 'heic',
  'image/heif': 'heif',
  'image/svg+xml': 'svg',
  'image/avif': 'avif',
  'image/bmp': 'bmp',
  [MIME_TYPE_PDF]: 'pdf',
  [MIME_TYPE_DOCX]: 'docx',
  [MIME_TYPE_DOC]: 'doc',
  'video/mp4': 'mp4',
  'video/webm': 'webm',
  'video/quicktime': 'mov',
  [MIME_TYPE_STEP]: 'step',
  [MIME_TYPE_GLB]: 'glb',
}

const contentTypesImage = [
  'image/png',
  'image/jpeg',
  'image/webp',
  'image/svg+xml',
  'image/avif',
  'image/heic',
  'image/heif',
]
const contentTypesVideoForBrowser = [
  'video/mp4',
  'video/h264',
  'video/webm',
  'video/AV1',
  'video/VP8',
  'video/VP9',
  'video/quicktime',
]

const contentTypesCsv = [MIME_TYPE_CSV]
const contentTypesStep = [MIME_TYPE_STEP]
const contentTypesCad = [MIME_TYPE_STEP, MIME_TYPE_GLB]

export enum ContentTypeGroup {
  IMAGE,
  VIDEO_FOR_BROWSER,
  UNKNOWN,
}
const getContentTypeGroup = (contentType: string) => {
  if (contentTypesImage.includes(contentType)) {
    return ContentTypeGroup.IMAGE
  }
  if (contentTypesVideoForBrowser.includes(contentType)) {
    return ContentTypeGroup.VIDEO_FOR_BROWSER
  }

  return ContentTypeGroup.UNKNOWN
}

export function getExtensionFromMimeType(mimeType: string): string | undefined {
  return mimeTypeToExtension[mimeType.toLowerCase()]
}

export function getExtensionFromFile(file: File): string {
  const name = (file.name || '').toLowerCase()
  if (name.includes('.')) {
    const ext = name.split('.').pop() || ''
    if (ext) {
      return ext
    }
  }
  const type = (file.type || '').toLowerCase()
  return getExtensionFromMimeType(type) || ''
}

export function inferContentType(file: { type?: string; name?: string }): string {
  const reportedType = (file.type || '').trim()
  // Only infer when the browser provides an empty type; otherwise trust the reported type.
  if (reportedType) {
    return reportedType
  }

  const name = (file.name || '').toLowerCase()
  const ext = name.includes('.') ? name.split('.').pop() || '' : ''

  return extensionToMimeType[ext] || 'application/octet-stream'
}

export default function () {
  return {
    contentTypesImage,
    contentTypesVideoForBrowser,
    contentTypesCsv,
    contentTypesStep,
    contentTypesCad,
    getContentTypeGroup,
  }
}
